<template>
  <div style="height: 100%">
<!--    <el-button size="mini" type="primary" @click="fetchISOData">更新数据</el-button>-->
    <!--<iosLiseO :map-data="isodata"/>-->
    <iosLise ref="iosLise" :map-data="isodata" v-on="{generateISO:fetchISOData,generateLocalISO:fetchLocalISOData}" v-if="isGenerated" style="height: 100%"/>
<!--    <ios-lise/>-->
  </div>
</template>

<script>
import axios from "axios";
import {ElLoading,ElMessageBox} from "element-plus";
//import IosLiseO from "@/components/iosLiseO.vue";
import IosLise from "@/components/iosLise.vue";

export default {
  name: "iso-View",
  components: {IosLise},
  mounted(){
    console.log(123)
    // this.fetchISOData();
  },
  data(){
    return {
      isGenerated:true,
      isodata:{
        mapName:"",
        isoRegions:[],
        isoLines:[],
        faults:[],
        points:[],
        scatterDat:[],//drawScatterDat
        boundary:{
          left:0,
          right:0,
          top:0,
          bottom:0
        },
        imageShow:false
      }
    }
  },
  methods: {
    fetchISOData(gridCfgData) {
      console.log(this.$refs.iosLise)
      let loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      axios.post(process.env.VUE_APP_SERVER + "/fileprocesser/generateIso",gridCfgData)
        .then(res=>{
          console.log(".......................",res.data)
          //this.isodata = res.data;
          // let top = JSON.parse(JSON.stringify(res.data.boundary.top));
          // let bottom = JSON.parse(JSON.stringify(res.data.boundary.bottom))
          this.isGenerated = true;
          this.isodata.boundary = res.data.boundary;
          let boundaryWidth = Math.abs(this.isodata.boundary.right-this.isodata.boundary.left);
          let boundaryHeight = Math.abs(this.isodata.boundary.top-this.isodata.boundary.bottom);
          let tkWidth = Math.min(boundaryHeight,boundaryWidth);
          tkWidth = tkWidth/20;
          this.isodata.boundary.top = this.isodata.boundary.top+tkWidth;
          this.isodata.boundary.bottom = this.isodata.boundary.bottom-tkWidth;
          this.isodata.boundary.left = this.isodata.boundary.left-tkWidth;
          this.isodata.boundary.right = this.isodata.boundary.right+tkWidth;
          this.isodata.boundary.tkWidth = tkWidth;
          // this.isodata.boundary.top *= -1;
          // this.isodata.boundary.bottom *= -1;
          this.isodata.faults = res.data.faults;
          this.isodata.imageShow = false;
          this.isodata.isoLines = res.data.isoLines;
          // for(let i in this.isodata.isoLines){
          //   for(let j in this.isodata.isoLines[i].lines){
          //     for(let k in this.isodata.isoLines[i].lines[j]){
          //        this.isodata.isoLines[i].lines[j][k].y*=-1;
          //     }
          //   }
          // }
          this.isodata.isoRegions = res.data.isoRegions;
          this.isodata.mapName = "等值线图";
          this.isodata.points = res.data.points==undefined?[]:res.data.points;
          this.isodata.baseMap = res.data.baseMap==undefined?{}:res.data.baseMap;
          if(res.data.baseMap!=undefined){
            this.isodata.imageShow = true;
          }
          this.isodata.blkBoundary = res.data.blkBoundary==undefined?{}:res.data.blkBoundary;
          let w = this.$refs.iosLise.$el.offsetWidth;
          w*=0.916666666667
          w-=200;
          let h = this.$refs.iosLise.$el.offsetParent.offsetHeight;
          h-=45;
          h-=48;
          h-=28;
          console.log("这里是wh",w,h)
          let dataBottom = this.isodata.boundary.bottom;
          let dataTop = this.isodata.boundary.top;
          let dataLeft = this.isodata.boundary.left;
          let dataRight = this.isodata.boundary.right;
          let ch = dataTop;
          ch -= dataBottom;
          // console.log("dataHeight",ch)
          let cw = dataRight;
          cw -= dataLeft;
          // console.log("dataWidth",cw)
          let aspectRatio = w;
          aspectRatio/=h;
          // console.log("w/h",aspectRatio,w,h,cw,ch,cw/ch)
          // console.log("=============")
          // console.log(ch,cw)
          if(aspectRatio<cw/ch){
            // console.log("走的这里啦")
            // console.log(aspectRatio)
            // console.log("ch",ch)
            // console.log("cw",cw)
            let y = cw;
            y /= aspectRatio;
            y-= ch;
            y/=2;
            this.isodata.boundary.top+=y;
            this.isodata.boundary.bottom-=y;
            this.isodata.boundary.x = 0;
            this.isodata.boundary.y = y;
          }else
          {
            console.log("还是这里呢")
            console.log(aspectRatio)
            console.log("ch",ch)
            console.log("cw",cw)
            let x = ch;
            x*=aspectRatio;
            x-= cw;
            x/=2;
            this.isodata.boundary.left-=x;
            this.isodata.boundary.right+=x;
            this.isodata.boundary.x = x;
            this.isodata.boundary.y = 0;
          }
          this.isodata.height=this.$refs.iosLise.$el.offsetParent.offsetHeight
          this.isodata.scatterDat = res.data.drawScatterDat;
          console.log(">>>>>>>>>>>",this.isodata)
          this.$store.state.isoData = this.isodata;
          this.$refs.mapData = this.isodata;
          this.$refs.iosLise.getData();
          // this.$refs.iosLise.clearCanvas();
          // this.$refs.iosLise.clearPoint();
          // this.$refs.iosLise.clearBlock();
          // this.$refs.iosLise.getData();
          // this.$refs.iosLise.draw();
          loading.close()
        }).catch(err=>{
        ElMessageBox('Error');
        console.log(err)
        loading.close()
      })
    },
    fetchLocalISOData(gridCfgLocalData) {
      let loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let parmStr = "dspStep="+gridCfgLocalData.dspStep;
      parmStr += "&sbRefineTimes="+gridCfgLocalData.sbRefineTimes;
      parmStr += "&dsbFaultAffectRange="+gridCfgLocalData.dsbFaultAffectRange;
      parmStr += "&sbSmoothTimes="+gridCfgLocalData.sbSmoothTimes;
      parmStr += "&spDataRelable="+gridCfgLocalData.spDataRelable;
      parmStr += "&sldSmooth="+gridCfgLocalData.sldSmooth;
      parmStr += "&dsbIntv="+gridCfgLocalData.dsbIntv;
      parmStr += "&cbInterMethod="+gridCfgLocalData.cbInterMethod;
      parmStr += "&isNeedBorder="+gridCfgLocalData.isNeedBorder;
      parmStr += "&isNeedFault="+gridCfgLocalData.isNeedFaul;
      let wellPoint = gridCfgLocalData.wellData;
      gridCfgLocalData.gridBody.wellDats = wellPoint;
      //axios.post(process.env.VUE_APP_SERVER + "/fileprocesser/generateLocalIso?"+parmStr,gridCfgLocalData.gridBody)
      axios({
        url: process.env.VUE_APP_SERVER + "/fileprocesser/generateLocalIso?"+parmStr,
        headers: {
          "Authorization": "Bearer " + gridCfgLocalData.jwt
        },
        data: gridCfgLocalData.gridBody,
        method: 'POST',
      }).then(res=>{
            console.log(".......................",res.data)
            //this.isodata = res.data;
            // let top = JSON.parse(JSON.stringify(res.data.boundary.top));
            // let bottom = JSON.parse(JSON.stringify(res.data.boundary.bottom))
            this.isGenerated = true;
            this.isodata.boundary = res.data.boundary;
            let boundaryWidth = Math.abs(this.isodata.boundary.right-this.isodata.boundary.left);
            let boundaryHeight = Math.abs(this.isodata.boundary.top-this.isodata.boundary.bottom);
            let tkWidth = Math.min(boundaryHeight,boundaryWidth);
            tkWidth = tkWidth/20;
            this.isodata.boundary.top = this.isodata.boundary.top+tkWidth;
            this.isodata.boundary.bottom = this.isodata.boundary.bottom-tkWidth;
            this.isodata.boundary.left = this.isodata.boundary.left-tkWidth;
            this.isodata.boundary.right = this.isodata.boundary.right+tkWidth;
            this.isodata.boundary.tkWidth = tkWidth;
            // this.isodata.boundary.top = bottom;
            // this.isodata.boundary.bottom = top;
            // this.isodata.boundary.top *= -1;
            // this.isodata.boundary.bottom *= -1;
            this.isodata.faults = res.data.faults;
            this.isodata.imageShow = false;
            this.isodata.isoLines = res.data.isoLines;
            // for(let i in this.isodata.isoLines){
            //   for(let j in this.isodata.isoLines[i].lines){
            //     for(let k in this.isodata.isoLines[i].lines[j]){
            //        this.isodata.isoLines[i].lines[j][k].y*=-1;
            //     }
            //   }
            // }
            this.isodata.isoRegions = res.data.isoRegions;
            this.isodata.mapName = "等值线图";
            this.isodata.points = wellPoint;
            // if(wellPoint.length>0){
            //   this.isodata.points = wellPoint;
            // }
            // else{
            //   this.isodata.points = res.data.points==undefined?[]:res.data.points;
            // }
            this.isodata.baseMap = res.data.baseMap==undefined?{}:res.data.baseMap;
            if(res.data.baseMap!=undefined){
              this.isodata.imageShow = true;
            }
            this.isodata.blkBoundary = res.data.blkBoundary==undefined?{}:res.data.blkBoundary;
            let w = this.$refs.iosLise.$el.offsetWidth;
            w*=0.916666666667
            w-=200;
            let h = this.$refs.iosLise.$el.offsetParent.offsetHeight;
            h-=45;
            h-=48;
            h-=28;
            console.log("这里是wh",w,h)
            let dataBottom = this.isodata.boundary.bottom;
            let dataTop = this.isodata.boundary.top;
            let dataLeft = this.isodata.boundary.left;
            let dataRight = this.isodata.boundary.right;
            let ch = dataTop;
            ch -= dataBottom;
            console.log("dataHeight",ch)
            let cw = dataRight;
            cw -= dataLeft;
            console.log("dataWidth",cw)
            let aspectRatio = w;
            aspectRatio/=h;
            console.log("w/h",aspectRatio)
            console.log("=============")
            console.log(ch,cw)
            if(aspectRatio<cw/ch){
              console.log("走的这里啦")
              console.log(aspectRatio)
              console.log("ch",ch)
              console.log("cw",cw)
              let y = cw;
              y /= aspectRatio;
              y-= ch;
              y/=2;
              this.isodata.boundary.top+=y;
              this.isodata.boundary.bottom-=y;
              this.isodata.boundary.x = 0;
              this.isodata.boundary.y = y;
            }else
        {
              console.log("还是这里呢")
              console.log(aspectRatio)
              console.log("ch",ch)
              console.log("cw",cw)
              let x = ch;
              x*=aspectRatio;
              x-= cw;
              x/=2;
              this.isodata.boundary.left-=x;
              this.isodata.boundary.right+=x;
              this.isodata.boundary.x = x;
              this.isodata.boundary.y = 0;
            }
            this.isodata.height=this.$refs.iosLise.$el.offsetParent.offsetHeight
            console.log(">>>>>>>>>>>",this.isodata)
            this.$store.state.isoData = this.isodata;
            this.$refs.mapData = this.isodata;
            this.$refs.iosLise.getData();
            // this.$refs.iosLise.clearCanvas();
            // this.$refs.iosLise.clearPoint();
            // this.$refs.iosLise.clearBlock();
            // this.$refs.iosLise.getData();
            // this.$refs.iosLise.draw();
            loading.close()
          }).catch(err=>{
        ElMessageBox('Error');
        console.log(err)
        loading.close()
      })
    }
  },

}
</script>